import { useQuery } from "@tanstack/react-query";
import { CertificateDictionaryModel } from "../../models/certificate.model";
import { certificateDictionaryService } from "../../services/dictionaries";

export const useCertificatesDictionary = () => {
  return useQuery({
    queryKey: ["certificates", "dictionary"],
    queryFn: async (): Promise<CertificateDictionaryModel[]> => {
      return certificateDictionaryService.getCertificatesDictionary();
    },
    staleTime: 1000 * 60 * 15, // 15 minutes - dictionary data doesn't change often
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
